import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {goToPage, updateDocumentTitle} from "../../Utils/Common";
import {useHistory} from "react-router-dom";
import PageLayout from "../Layout/PageLayout";
import {Toolbar, SearchInput, Button, Tabs} from "../UI";

const Search = props => {

    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [code, setCode] = useState('');
    const [results, setResults] = useState('');
    const [resultTab, setResultTab] = useState('requests');

    useEffect(() => {
        updateDocumentTitle("Search")
    }, []);

    const searchItems = e => {
        e.preventDefault();

        let data = new FormData();
        data.append("code", code)

        setIsLoading(true);

        postData(Endpoints.REQUEST_RECEIVE, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setCode('');
                    Notify(res.data, SUCCESS);
                    goToPage(history, "/requests/cc")
                } else {
                    if (Array.isArray(res.message)) {
                        Notify(res.message[0], ERROR);
                    } else {
                        Notify(res.message, ERROR);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }


    return (
        <PageLayout title="Search for requests, clients, riders, businesses etc.">
            <form>
                <Toolbar>
                    <SearchInput
                        type="text"
                        required={true}
                        placeholder="Type here..."
                        value={code}
                        onChange={e => setCode(e.target.value)}
                    />
                    <Toolbar.Spacer/>
                    <Button type="submit" loading={isLoading} onClick={e => searchItems(e)}>Search</Button>
                </Toolbar>
            </form>

            {!isLoading &&
            <Tabs
                tabs={[
                    {key: "requests", label: "Requests"},
                    {key: "clients", label: "Clients"},
                    {key: "riders", label: "Riders"},
                    {key: "businesses", label: "Businesses"},
                ]}
                value={resultTab}
                onChange={setResultTab}
            />
            }
        </PageLayout>
    )
};

export default Search;
